import { t, STAFF_PASSWORD_MIN_LENGTH, UUID, Money, DateTimeISO, Status } from '../common.ts';

export const PartnerView = t.Object(
  {
    id: UUID,
    username: t.String(),
    kind: t.Union([t.Literal('affiliate'), t.Literal('partner')]),
    level: t.Integer(),
    status: Status,
    reserveCredit: Money,
    createdAt: DateTimeISO,
  },
  { $id: 'PartnerView' },
);

export const CreatePartnerRequest = t.Object(
  {
    username: t.String({ minLength: 3, maxLength: 64 }),
    password: t.String({ minLength: STAFF_PASSWORD_MIN_LENGTH, maxLength: 128 }),
    kind: t.Union([t.Literal('affiliate'), t.Literal('partner')]),
    reserveCreditAmount: t.Optional(Money),
  },
  { $id: 'CreatePartnerRequest' },
);

export const CommissionClaimView = t.Object(
  {
    id: UUID,
    memberId: UUID,
    kind: t.Union([t.Literal('commission'), t.Literal('referral'), t.Literal('affiliate')]),
    periodKey: t.String(),
    amount: Money,
    breakdown: t.Record(t.String(), t.Unknown()),
    claimedAt: DateTimeISO,
    txId: t.Union([UUID, t.Null()]),
  },
  { $id: 'CommissionClaimView' },
);

export const UpgradeMemberToPartnerRequest = t.Object(
  {
    memberId: UUID,
    reserveCreditAmount: Money,
    reason: t.String({ minLength: 10, maxLength: 500 }),
  },
  { $id: 'UpgradeMemberToPartnerRequest' },
);

export const AffiliateGroupView = t.Object(
  {
    id: UUID,
    agentId: t.Union([UUID, t.Null()]),
    name: t.String(),
    description: t.Union([t.String(), t.Null()]),
    subSharePercentBp: t.Integer(),
    status: Status,
  },
  { $id: 'AffiliateGroupView' },
);

export const AffiliateSettlementView = t.Object(
  {
    id: UUID,
    partnerId: UUID,
    periodKey: t.String(),
    model: t.String(),
    grossWinloss: t.Integer(),
    companyDeduction: t.Integer(),
    winlossAfterCompany: t.Integer(),
    expenses: t.Integer(),
    lossShare: t.Integer(),
    turnoverShare: t.Integer(),
    ftdBonus: t.Integer(),
    subLineShare: t.Integer(),
    grossShare: t.Integer(),
    carryIn: t.Integer(),
    netAmount: t.Integer(),
    status: Status,
  },
  { $id: 'AffiliateSettlementView' },
);

export const AffiliatePayoutView = t.Object(
  {
    id: UUID,
    partnerId: UUID,
    periodKey: t.String(),
    action: t.String(),
    amount: t.Integer(),
    proofUrl: t.Union([t.String(), t.Null()]),
    txId: t.Union([UUID, t.Null()]),
  },
  { $id: 'AffiliatePayoutView' },
);
